import { signal } from 'services/SignalsService'

const name = 'FS-END'

async function execute() {
  signal.dispatch('REELS:UPDATE')
  return signal.promise('BUTTON:endFreespin')
}

export function getFreespinsEndAction() {
  return {
    name,
    execute,
  }
}
